import { AlertsTab, type AlertsTabProps } from "@components/job_alerts/alerts_tab.tsx";
import { SearchTab, type SearchTabProps } from "@components/job_search/search_tab.tsx";

type Props = ({ tab: "search" } & SearchTabProps) | ({ tab: "alerts" } & AlertsTabProps);

const Jobs = (props: Props) =>
  props.tab === "alerts" ? <AlertsTab {...props} /> : <SearchTab {...props} />;

export default Jobs;
